/**
 * BadgeHelpButton — tiny round "?" button placed next to a document status badge.
 *
 * On click it triggers an `onOpen(sectionId)` callback so the parent page can
 * open the EmployeeGuideDialog scrolled to the corresponding section.
 *
 * Usage:
 *   <Badge ...>Presa visione richiesta</Badge>
 *   <BadgeHelpButton sectionId="ack" onOpen={setHelpSection} label="Cosa significa?" />
 */
import { HelpCircle } from "lucide-react";

export const BadgeHelpButton = ({
    sectionId,
    onOpen,
    label = "Cosa significa?",
    className = "",
    testid,
}) => (
    <button
        type="button"
        onClick={(e) => {
            // Stop event bubbling so badges that sit inside clickable rows don't
            // trigger their parent action (e.g. clicking a download row).
            e.stopPropagation();
            e.preventDefault();
            onOpen(sectionId);
        }}
        title={label}
        aria-label={label}
        className={`inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-[#376DB3]/10 hover:text-[#376DB3] focus:outline-none focus:ring-2 focus:ring-[#376DB3]/40 ${className}`}
        data-testid={testid || `badge-help-${sectionId}`}
    >
        <HelpCircle className="h-3.5 w-3.5" />
    </button>
);
